import { bootstrap } from './bootstrap'
import { setPlatformType } from './src/Config'

setPlatformType("BROWSER");

document.addEventListener("DOMContentLoaded", bootstrap);